import React from 'react';
import proptypes from 'prop-types';
const { node } = proptypes;

export const SuggestionsMenuFooter = ({
  footer
}) => {
  return (
    <>
      {footer && (
        <div
          id="suggestions-menu-footer"
          data-testid="suggestions-menu-footer"
        >
          {footer}
        </div>
      )}
    </>
  );
};

SuggestionsMenuFooter.displayName = 'SuggestionsMenuFooter';
SuggestionsMenuFooter.propTypes = {
  footer: node
};
SuggestionsMenuFooter.defaultProps = {
  footer: null
};
